import { CaliWaterTiles, NebraskaWaterTiles } from '@/models/water';

export enum AcresMapboxLayerIds {
  // CLU
  CLU = 'clu',
  CLU_FILL = 'clu-fill',
  CLU_LABELS = 'clu-labels',
  ACTIVE_CLU = 'active-clu',
  CLU_CENTROIDS = 'clu-centroids',
  CLU_CENTROID_INTERSECTION_LABEL_CENTROIDS = 'clu-intersection-label-centroids',

  // Comps
  USER_COMPS = 'user-comps',
  COURTHOUSE_COMPS = 'courthouse-comps',
  COURTHOUSE = 'courthouse-layer',
  COMP_AUCTION = 'acretrader-auction',
  COMP_ACRETRADER = 'acretrader',
  COMP_REJECTED = 'acretrader-rejected',
  COMP_SALE = 'acretrader-sale',

  // Advanced search layers
  ADVANCEDSEARCH_FILL = 'advancedsearch-parcel-fill',
  ADVANCEDSEARCH_OUTLINE = 'advancedsearch-parcel-line',
  ADVANCEDSEARCH_DOT = 'advancedsearch-parcel-dot',

  // County
  COUNTY_HIGHLIGHT = 'county_highlight',
  COUNTY_LABEL = 'county-label',
  COUNTY_OUTLINE = 'county-outline',
  COUNTY_FILL = 'county-fill',
  COUNTY = 'county-layer',
  COUNTY_FILL_ALT = 'county-fill-alt',
  COUNTY_FILL_MAX_ZOOM = 'county-fill-max-zoom',

  // Customized Land
  POLYGON_LAYER_ID = 'customized-poly-layer',
  FENCE_LAYER_ID = 'customized-fence-layer',
  OUTLINE_LAYER_ID = 'outline',
  POLYGON_FILL_LAYER_ID = 'customized-poly-fill-layer',
  FENCE_FILL_LAYER_ID = 'customized-fence-fill-layer',
  POINT_LAYER_ID = 'customized-point-layer',
  SYMBOL_LAYER_ID = 'customized-symbol-layer',

  // Draw
  DRAW_FILL = 'draw-fill',

  // Elevation
  ELEVATION_CONTOUR = 'elevation_contour',
  ELEVATION_CONTOUR_WIDE = 'elevation_contour_wide',
  ELEVATION_COLOR = 'elevation_color',

  // Flood
  FLOOD = 'acremaps-flood',
  WETLANDS = 'wetlands',
  FLOOD_LABELS = 'flood-labels',
  FLOOD_META_LABELS = 'flood-meta-labels',
  FLOOD_LABELS_FILL = 'flood-labels-fill',
  // GEOJSON
  GEOJSON_OUTLINE = 'geojson-outline',
  GEOJSON_FILL = 'geojson-fill',

  // Insights
  CROP = 'crop',
  NDVI = 'ndvi',
  CROP_HISTORY = 'crop-history',
  SURFACE_WATER = 'surface-water',
  HISTORICAL_IMAGERY = 'historical-imagery',
  WATER = 'water',
  ELEVATION = 'elevation',
  SOIL = 'soil',
  POWER_LINES = 'transmission_lines',
  SUBSTATIONS = 'substations',
  TIMBER_SITE_INDEX = 'timber-productivity-layer',
  TIMBER_SITE_INDEX_LINE = 'timber-productivity-line-layer',

  // Location
  LOCATION = 'location',

  // Parcels
  PARCEL = 'parcels',
  PARCEL_ID = 'points',
  PARCEL_OUTLINE_HOVER = 'parcels-outline-hover',
  PARCEL_OUTLINE = 'parcels-outline',
  PARCEL_PARTIAL = 'partial-parcels',
  PARCEL_OWNER_LABEL = 'visible-owner-labels',

  // Portfolio
  PORTFOLIO_CENTROIDS = 'portfolio-centroids',
  PORTFOLIO_SAVED_SELECTIONS = 'portfolio-saved-selections',
  PORTFOLIO_SAVED_SELECTIONS_FILL = 'portfolio-saved-selections-fill',
  PORTFOLIO_COMPS = 'portfolio-map-comp-layer',

  // Property Tax
  SIBLING_PROPERTY_TAX_OUTLINE = 'sibling-parcels-line',
  SIBLING_PROPERTY_TAX_FILL = 'sibling-parcels-fill',

  // Real Estate
  REAL_ESTATE = 'public.real-estate-listings',
  REAL_ESTATE_OUTLINE = 'realEstateLine',
  REAL_ESTATE_FILL = 'realEstateFill',

  // Saved Selection
  SAVED_SELECTION = 'savedSelection',

  // Sections
  SECTION_LINE = 'section-line',
  SECTION_LABELS = 'section-labels',
  SECTION_OUTLINE = 'section-outline',
  SECTION_FILL = 'section-fill',
  SECTION_OUTLINE_PERMANENT = 'section-outline-permanent',

  // Selection
  SELECTION_OUTLINE = 'selectionLine',
  SELECTION_FILL = 'selectionFill',
  SELECTION_DOT = 'selection-dot',

  // States
  STATE_FILL = 'state-fill',
  STATE_LABEL = 'state-label',
  STATE_HIGHLIGHT = 'state-highlight',
  STATE_OUTLINE = 'state-outline',
  STATE_OUTLINE_PERMANENT = 'state-outline-permanent',

  // Timber
  TIMBER_MILLS = 'timber_mills',

  // Townships
  TOWNSHIP_LABELS = 'township-labels',
  TOWNSHIP_LINE = 'township-line',
  TOWNSHIP_FILL = 'township-fill',
  TOWNSHIP_OUTLINE = 'township-outline',
  TOWNSHIP_OUTLINE_PERMANENT = 'township-outline-permanent',

  ACTIVE_OUTLINE_LAYER = 'activeCompOutlineLayer',

  // Mortgage
  MORTGAGE = 'mortgage',
  ACTIVE_MORTGAGE_OUTLINE_LAYER = 'activeMortgageOutlineLayer',

  // Boundary
  BOUNDARY = 'boundary',
  BOUNDARY_OUTLINE = 'boundary-outline',
  BOUNDARY_EDIT = 'boundary-edit',
  BOUNDARY_EDIT_FILL = 'boundary-edit-fill',
  BOUNDARY_LABEL = 'boundary-label',
  BOUNDARY_LABEL_CIRCLE = 'boundary-label-circle',

  // Farm Rent
  FARM_RENT = 'farm-rent',
  ACTIVE_FARM_RENT_OUTLINE_LAYER = 'activeFarmRentOutlineLayer',

  // CA Water districts
  CA_WATER_DISTRICTS = CaliWaterTiles.WATER_DISTRICTS,
  CA_WATER_DISTRICTS_OUTLINE = `${CaliWaterTiles.WATER_DISTRICTS}-outline`,
  CA_SGMA = CaliWaterTiles.SGMA,
  CA_SGMA_OUTLINE = `${CaliWaterTiles.SGMA}-outline`,
  CA_GSA = CaliWaterTiles.GSA,
  CA_GSA_OUTLINE = `${CaliWaterTiles.GSA}-outline`,
  CA_ADJUDICATED_BASINS = CaliWaterTiles.ADJUDICATED_BASINS,
  CA_ADJUDICATED_BASINS_OUTLINE = `${CaliWaterTiles.ADJUDICATED_BASINS}-outline`,

  // Nebraska Water districts
  NE_NRD_OUTLINE = `${NebraskaWaterTiles.NEBRASKA_NRD}-outline`,
  NE_NRD = NebraskaWaterTiles.NEBRASKA_NRD,

  EMBED = 'embed',

  // Base Layers (from our style in mapbox)
  BASE_COUNTY_LAYER = 'County Boundary',
  BASE_STATE_LAYER = 'admin-1-boundary',
  BASE_COUNTRY_LAYER = 'admin-0-boundary',
  BASE_STATE_TRANSPARENTISH_LAYER = 'admin-0-boundary-bg',
  BASE_STATE_FILL_LAYER = 'admin-1-boundary-bg',
  BASE_STATE_LABELS = 'state-label',

  DEED_PLOTTER_LINE_BASE = 'deed-plotter-line-',
  DEED_PLOTTER_SYMBOL_BASE = 'deed-plotter-symbol-',
  DEED_PLOTTER_START_POINT_BASE = 'deed-plotter-start-point-',
  COG_CDL_CONTEXT_BASE = 'cog-cdl-context-',

  // 3D Buildings
  THREE_D_BUILDINGS = '3d-buildings',
}

export enum AcresMapboxSourceIds {
  STATES = 'state-source',
  SECTIONS = 'section-source',
  TOWNSHIPS = 'township-source',
  COUNTY_SUBDIVISIONS = 'county-subdivisions',
  TOWNSHIP_CENTROIDS = 'cousub-centroids',
  SOIL = 'soil-source',
  REAL_ESTATE = 'real-estate-source',
  PARCEL_ID = 'points',
  PARCELS = 'parcels',
  ELEVATION = 'elevation_source',
  POLYGON = 'customized-polygon-source',
  FENCE = 'customized-fence-source',
  COUNTIES = 'county-source',
  COUNTY_MAX_ZOOM = 'county-max-zoom-source',
  CORELOGIC_RESULTS = 'corelogic-results-polygons',
  COURTHOUSE = 'courthouse-source',
  USER_COMPS = 'user-comps',
  COURTHOUSE_COMPS = 'courthouse-comps',
  CLU = 'clu',
  CROP_HISTORY = 'crop-history',
  WATER = 'water',
  HISTORICAL_IMAGERY = 'historical-imagery',
  PARCEL_CENTROIDS = 'parcel-centroids',
  GEOJSON_OUTLINE = 'geojson-outline',
  GEOJSON_FILL = 'geojson-fill',
  PORTFOLIO_CENTROIDS = 'portfolio-centroids',
  PORTFOLIO_SAVED_SELECTIONS = 'portfolio-saved-selections',
  PORTFOLIO_COMPS = 'portfolio-map-comp-layer',
  TIMBER_SITE_INDEX = 'timber-productivity',
  MORTGAGE = 'mortgage',
  BOUNDARY = 'boundary',
  BOUNDARY_EDIT = 'boundary-edit',
  BOUNDARY_EDIT_FILL = 'boundary-edit-fill',
  BOUNDARY_LABEL = 'boundary-label',
  BOUNDARY_OUTLINE = 'boundary-outline',
  FARM_RENT = 'farm-rent',
  FLOOD = 'flood',
  WETLANDS = 'wetlands',
  MAPBOX_DEM = 'mapbox-dem',
  /** This is default for maptiler sdk and gets used internally, do not change */
  MAPTILER_TERRAIN = 'maptiler-terrain',

  // For whatever reason, the tile config gives us the kebab,
  // but the source layer is actually snake case
  /** From the tile config */
  TIMBER_MILLS_CONFIG = 'timber-mills',
  GOOGLE_RASTER_TILES = 'google-raster-tiles',
  TIMBER = 'timber',
  QUICK_MEASURE_SOURCE = 'quick-measure-source',
  QUICK_MEASURE_POINT_SOURCE = 'quick-measure-point-source',
  QUICK_MEASURE_LINE = 'quick-measure-line',
  CURRENT_LOCATION_DOT = 'dot-point',
  CUSTOMIZED_LAND = 'customizedLand',
  SAVED_LAND_DETAILS_CUSTOMIZATIONS = 'saved-land-details-customizations',
  MAPBOX = 'mapbox',
  COMPOSITE = 'composite',
  BUILDINGS = 'open-map-buildings',
}

/**
 * For layers with vector sources, you need to provide additional specification
 * for what layer inside the vector source. These ids are for keeping track of those.
 */
export enum AcresMapboxVectorSourceLayerIds {
  FLOOD = 'flood',
  FLOOD_META_LABELS = 'firm',
  WETLANDS = 'wetlands',
  CLU = 'clu',
  CLU_CENTROIDS = 'clu-centroids',
  COUNTY = 'county',
  COUNTY_CENTROID = 'county-centroids',
  PARCELS = 'parcels',
  PARCEL_CENTROIDS = 'parcel-centroids',
  REAL_ESTATE_LISTING = 'real_estate_listing',
  STATES = 'states',
  STATE_CENTROID = 'states-centroids',
  TIMBER_MILLS = 'timber_mills',
  SECTIONS = 'sections',
  SECTIONS_CENTROIDS = 'sections-centroids',
  COUSUB = 'cousub',
  TOWNSHIP_CENTROIDS = 'cousub-centroids',
  POWER_LINES = 'transmission_lines',
  SUBSTATIONS = 'substations',
  BUILDING = 'building',
}

export const ZOOM_LEVELS = {
  COUNTIES: {
    MAX: 11,
    MIN: 7,
  },
  PARCELS: {
    MAX: 22,
    MIN: 13,
  },
  SECTIONS: {
    MAX: 14,
    MIN: 12,
  },
  STATES: {
    MAX: 7,
    MIN: 3,
  },
  TOWNSHIPS: {
    MAX: 13,
    MIN: 10,
  },
};
